import BulkAddOnPanel from './bulk-addon-panel';

export default BulkAddOnPanel;
